import React, { useCallback } from 'react'

import { oneOf } from 'prop-types'

import FilterChip from 'Pods/SearchPage/Components/Shared/FilterChip/FilterChip'
import { FILTER_NAME } from 'Pods/SearchPage/Shared/Tracking/constants'
import { useTrackFilterSelect } from 'Pods/SearchPage/Shared/Tracking/FilterTracking'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { selectSubscriptionTier, toggleSubscriptionTier } from 'Pods/SearchPage/Store/actions/pricing'
import { SUBSCRIPTION_TIER } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'

function PlanChip({ tier }) {
  const translate = useTranslate()

  // A subscription search with no plan picked (an old "All" URL) spans every tier, which is what
  // Premium shows.
  const isChecked = useSearchPageStore((state) => {
    if (!state.withSubscription) return false
    if (!state.subscriptionTiers?.length) return tier === SUBSCRIPTION_TIER.PREMIUM

    return state.subscriptionTiers.includes(tier)
  })
  const trackFilterSelect = useTrackFilterSelect()

  const handleChange = useCallback((nextChecked) => {
    if (!nextChecked) {
      toggleSubscriptionTier(tier, false)
      return
    }

    trackFilterSelect(FILTER_NAME.PRICE, `subscription_tier_${tier}`)
    selectSubscriptionTier(tier)
  }, [tier, trackFilterSelect])

  return (
    <FilterChip
      id="quick-filter-in_my_plan"
      label={translate('search_page.filters.quick_filters.in_my_plan')}
      isChecked={isChecked}
      onChange={handleChange}
    />
  )
}

PlanChip.propTypes = {
  tier: oneOf(Object.values(SUBSCRIPTION_TIER)).isRequired,
}

export default PlanChip
